module.exports = __webpack_public_path__ + "img/User.7cf93312.svg";